







































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ProjectDetailLeftNav extends Vue {
  @Prop()
  private cState: any;
  @Prop()
  private project: any;
}
